export default "__VITE_ASSET__f0piHs$Y__"